export class ClipboardFeedback {
  constructor({ button, status = null, copiedLabel, errorLabel, timers = globalThis }) {
    this.button = button
    this.status = status
    this.copiedLabel = copiedLabel
    this.errorLabel = errorLabel
    this.timers = timers
    this.originalLabel = button.textContent
    this.timeout = null
  }

  async copy(text, writeText) {
    this.clear()
    this.#setStatus("")

    try {
      await writeText(text)
      this.button.textContent = this.copiedLabel
      this.#setStatus(this.copiedLabel)
      this.timeout = this.timers.setTimeout(() => {
        this.button.textContent = this.originalLabel
        this.timeout = null
      }, 2000)
      return true
    } catch (_error) {
      this.button.textContent = this.originalLabel
      this.#setStatus(this.errorLabel)
      return false
    }
  }

  clear() {
    if (this.timeout !== null) {
      this.timers.clearTimeout(this.timeout)
      this.timeout = null
    }
    this.button.textContent = this.originalLabel
  }

  #setStatus(text) {
    if (this.status) this.status.textContent = text
  }
}
